import { jsx as _jsx } from "react/jsx-runtime";
function index(_ref) { let { children } = _ref; return /*#__PURE__*/ _jsx("div", { style: { width: "100vw", height: "100vh", overflow: "hidden" }, children: children }); }
export default index;
